// extracted by mini-css-extract-plugin
export default {"body":"styles_body__RjaVb","addbutton":"styles_addbutton__vnLLg","actionButton":"styles_actionButton__KEkre"};